// ── DAILY LESSONS DATA ───────────────────────────────────────
// Based on Methods 3P+ (Pola Pikir, Pola Makan, Pola Tidur)

export const LESSONS = [
  {
    day: 1,
    title: 'Kenapa Pikiran Bisa Bikin Lambung Sakit?',
    phase: 'pola_pikir',
    estimatedDuration: '5 menit',
    content: `Assalamu'alaikum, Kak. Hari ini kita bahas koneksi otak-lambung yang sering diabaikan. Stres dan anxiety bukan "lebay" — ada jalur saraf nyata yang membuat pikiran cemas langsung memicu produksi asam lambung. Bismillah, kita mulai menjemput kembali perasaan AMAN di dalam tubuhmu sendiri.`,
    audioUrl: '/audio/h1-vn.mp3',
    audioGuideDuration: '4:20',
    deepdiveTopics: ['saraf-vagus-gut-brain'],
    xpReward: 100,
    keyPhrase: 'menjemput kembali perasaan AMAN di dalam tubuhmu sendiri'
  },
  {
    day: 2,
    title: 'Napas yang Menyembuhkan: Teknik Vagal Toning',
    phase: 'pola_pikir',
    estimatedDuration: '6 menit',
    content: `Saraf vagus adalah "rem" sistem saraf. Dzikir dan pernapasan dalam bukan sekadar ibadah — secara biologis, keduanya mengaktifkan saraf vagus dan meredam produksi kortisol. Ingat ya Kak, hembusan napas panjang adalah perintah mutlak bagi saraf untuk masuk ke mode Rest & Digest.`,
    audioUrl: '/audio/h2-vn.mp3',
    audioGuideDuration: '5:15',
    deepdiveTopics: ['protokol-napas-446'],
    xpReward: 100,
    keyPhrase: 'hembusan napas panjang adalah perintah mutlak bagi saraf untuk masuk ke mode Rest & Digest'
  },
  {
    day: 3,
    title: 'Jebakan Food Fear: Takut Makan Justru Bikin Makin Sakit',
    phase: 'pola_pikir',
    estimatedDuration: '5 menit',
    content: `Banyak penderita GERD jadi fobia makan karena trauma kambuh. Padahal kecemasan saat makan itu sendiri yang memperparah kondisi. Rasa takut itu SENDIRI yang seringkali membuat lambungmu MAKIN SENSITIF.`,
    audioUrl: '/audio/h3-vn.mp3',
    audioGuideDuration: '4:45',
    deepdiveTopics: ['mindful-eating-gerd'],
    xpReward: 100,
    keyPhrase: 'Rasa takut itu SENDIRI yang seringkali membuat lambungmu MAKIN SENSITIF'
  },
  {
    day: 4,
    title: 'Gema Masa Lalu: Kenapa Masih Ada Sensasi?',
    phase: 'pola_pikir',
    estimatedDuration: '5 menit',
    content: `Jika hari ini masih ada sensasi, jangan panik. Itu hanya 'Gema' dari kebiasaan lama saraf yang sedang proses memudar. Tubuhmu sedang renovasi, Kak.`,
    audioUrl: '/audio/h4-vn.mp3',
    audioGuideDuration: '4:30',
    deepdiveTopics: ['progress-check-troubleshoot'],
    xpReward: 100,
    keyPhrase: "Itu hanya 'Gema' dari kebiasaan lama saraf yang sedang proses memudar"
  },
  {
    day: 5,
    title: 'Sains Ilahiyah: Ritme Makan Tuma\'ninah',
    phase: 'pola_makan',
    estimatedDuration: '7 menit',
    content: `Masuk ke fase pola makan. Ini bukan sekadar anjuran agama — ini adalah Sains Ilahiyah. Makan pelan, kunyah 33x, dan berhenti sebelum kenyang adalah cara terbaik menjaga katup lambung.`,
    audioUrl: '/audio/h5-vn.mp3',
    audioGuideDuration: '6:00',
    deepdiveTopics: ['aturan-sepertiga'],
    xpReward: 100,
    keyPhrase: 'Ini bukan sekadar anjuran agama — ini adalah Sains Ilahiyah'
  },
  {
    day: 6,
    title: 'Walmagh: Semen Biologis Lambungmu',
    phase: 'pola_makan',
    estimatedDuration: '6 menit',
    content: `Walmagh adalah 'Semen'-nya, dan tugasmu memastikan semen itu tidak rusak sebelum kering. Jangan diguyur kopi atau cabai dulu ya, biarkan ia menambal dengan sempurna.`,
    audioUrl: '/audio/h6-vn.mp3',
    audioGuideDuration: '5:30',
    deepdiveTopics: ['walmagh-science'],
    xpReward: 100,
    keyPhrase: "Walmagh adalah 'Semen'-nya, dan tugasmu memastikan semen itu tidak rusak sebelum kering"
  },
  {
    day: 7,
    title: 'Regenerasi Total: 14 Hari Menuju Pulih',
    phase: 'pola_makan',
    estimatedDuration: '5 menit',
    content: `Tahukah Kakak? Sel lambung itu butuh waktu 14 hari untuk regenerasi total. Kita sudah di tengah jalan, jangan menyerah sekarang.`,
    audioUrl: '/audio/h7-vn.mp3',
    audioGuideDuration: '4:15',
    deepdiveTopics: ['cellular-regeneration'],
    xpReward: 100,
    keyPhrase: 'sel lambung itu butuh waktu 14 hari untuk regenerasi total'
  },
  {
    day: 8,
    title: 'Sensasi Nyata, Bahaya Tidak Nyata',
    phase: 'pola_makan',
    estimatedDuration: '6 menit',
    content: `Saat sensasi datang, katakan pada diri sendiri: Sensasinya NYATA, tapi bahayanya GAK NYATA. Allah menjagaku, aku aman.`,
    audioUrl: '/audio/h8-vn.mp3',
    audioGuideDuration: '5:00',
    deepdiveTopics: ['emergency-protocol'],
    xpReward: 100,
    keyPhrase: 'Sensasinya NYATA, tapi bahayanya GAK NYATA. Allah menjagaku, aku aman'
  },
  {
    day: 9,
    title: 'Otot yang Lelah, Bukan Mati',
    phase: 'pola_makan',
    estimatedDuration: '5 menit',
    content: `Kelemahan otot katup lambung (LES) ini BUKAN kematian otot permanen — ini hanya kehilangan sementara elastisitas karena asam yang terus mengiritasi.`,
    audioUrl: '/audio/h9-vn.mp3',
    audioGuideDuration: '4:50',
    deepdiveTopics: ['nutrisi-weight-recovery'],
    xpReward: 100,
    keyPhrase: 'Ini BUKAN kematian otot permanen — ini hanya kehilangan sementara'
  },
  {
    day: 10,
    title: 'Kambuh adalah Bagian dari Sembuh',
    phase: 'pola_makan',
    estimatedDuration: '5 menit',
    content: `ITU BUKAN KEMUNDURAN — itu tanda penyembuhan sedang aktif. Seperti luka yang gatal saat mau kering, lambung pun begitu.`,
    audioUrl: '/audio/h10-vn.mp3',
    audioGuideDuration: '4:40',
    deepdiveTopics: ['tanda-penyembuhan'],
    xpReward: 100,
    keyPhrase: 'ITU BUKAN KEMUNDURAN — itu tanda penyembuhan sedang aktif'
  },
  {
    day: 11,
    title: 'Menutup Hari dengan Benar',
    phase: 'pola_tidur',
    estimatedDuration: '7 menit',
    content: `Masuk fase pola tidur. Masalahnya bukan malemnya — kita belum pernah diajarkan cara menutup hari dengan benar. Yuk kita benahi ritual malam kita.`,
    audioUrl: '/audio/h11-vn.mp3',
    audioGuideDuration: '6:15',
    deepdiveTopics: ['sleep-hygiene-gerd'],
    xpReward: 100,
    keyPhrase: 'Masalahnya bukan malemnya — kita belum pernah diajarkan cara menutup hari dengan benar'
  },
  {
    day: 12,
    title: 'Obat Termurah: Tidur Awal',
    phase: 'pola_tidur',
    estimatedDuration: '5 menit',
    content: `Tidur awal adalah cara paling murah dan ampuh untuk membantu Walmagh bekerja. Saat tidur, tubuh melakukan shift malam untuk repair sel.`,
    audioUrl: '/audio/h12-vn.mp3',
    audioGuideDuration: '4:30',
    deepdiveTopics: ['melatonin-science'],
    xpReward: 100,
    keyPhrase: 'Tidur awal adalah cara paling murah dan ampuh untuk membantu Walmagh bekerja'
  },
  {
    day: 13,
    title: 'Tubuh adalah Amanah',
    phase: 'pola_tidur',
    estimatedDuration: '6 menit',
    content: `Tubuhmu adalah amanah, dan Allah tidak akan membiarkan hamba-Nya berjuang sendirian. Kita hanya perlu menjaga amanah ini dengan sabar.`,
    audioUrl: '/audio/h13-vn.mp3',
    audioGuideDuration: '5:45',
    deepdiveTopics: ['body-scan-grounding'],
    xpReward: 100,
    keyPhrase: 'Tubuhmu adalah amanah, dan Allah tidak akan membiarkan hamba-Nya berjuang sendirian'
  },
  {
    day: 14,
    title: 'Ini Adalah Fondasi',
    phase: 'pola_tidur',
    estimatedDuration: '8 menit',
    content: `Alhamdulillah, 14 hari terlewati. Ini bukan garis finis. Ini adalah Fondasi. Sekarang Kakak sudah punya alat untuk menjaga kesehatan selamanya.`,
    audioUrl: '/audio/h14-vn.mp3',
    audioGuideDuration: '7:00',
    deepdiveTopics: ['alumni-maintenance'],
    xpReward: 100,
    keyPhrase: 'Ini bukan garis finis. Ini adalah Fondasi.'
  }
];

export const getLessonByDay = (day) => LESSONS.find(l => l.day === day);
